<template>
  <div class="main-header">
    <v-toolbar dense>
      <v-tabs align-with-title>
        <template v-for="item in menuList">
          <v-tab
            v-if="!item.isHidden"
            :key="`${ item.name }-menu-item`"
            :to="item.path"
          >
            {{ item.name }}
          </v-tab>
        </template>

        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="primary"
              v-on="on"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              v-for="item in visibleMenuDropdownItems"
              :key="`${ item.name }-dropdown-menu-item`"
              dense
              :to="item.path"
            >
              {{ item.name }}
            </v-list-item>
          </v-list>
        </v-menu>
      </v-tabs>

      <v-spacer />
      <slot />
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: "MainHeader",

  computed: {
    isAdmin() {
      return this.$store.getters["AuthorizationStore/getUserIsAdmin"];
    },
    isEditor() {
      return this.$store.getters["AuthorizationStore/getUserIsEditor"];
    },
    menuDropdownItems() {
      return [
        {
          name: "Users Management",
          path: "/users",
          isHidden: !this.isAdmin
        },
        {
          name: "Safeguarding Europe",
          path: { name: "Safeguard", params: { license: "EUROPE" }}
        },
        {
          name: "Safeguarding UK",
          path: { name: "Safeguard", params: { license: "UK" }}
        },
        {
          name: "Safeguarding Canada",
          path: { name: "Safeguard", params: { license: "CA" }}
        },
        {
          name: "Safeguarding UK V2",
          path: { name: "SafeguardV2", params: { license: "UK" }}
        },
        {
          name: "Safeguarding Europe V2",
          path: { name: "SafeguardV2", params: { license: "EUROPE" }}
        },
        {
          name: "Safeguarding Canada V2",
          path: { name: "SafeguardV2", params: { license: "CA" }}
        },
        {
          name: "Analyzer",
          path: { name: "Analyzer", query: { type: "Summaries" }}
        },
        {
          name: "Provider Rates",
          path: "/provider-rates"
        },
        {
          name: "Provider Configuration",
          path: "/provider-configuration",
          isHidden: !this.isEditor
        },
        {
          name: "Audit Log - Rates",
          path: "/audit-log-rates"
        },
        {
          name: "Audit Log - Base Payout Providers",
          path: "/audit-log-payout"
        },
        {
          name: "Audit Log - Fees",
          path: "/audit-log-fees"
        }
      ];
    },

    visibleMenuDropdownItems() {
      return this.menuDropdownItems.filter(item => !item.isHidden);
    },

    menuList() {
      return [
        {
          name: "Pricing Automation",
          path: "/autopricing"
        },
        {
          name: "Fees",
          path: "/fees"
        },
        {
          name: "Payin Fees",
          path: "/payin-fees"
        },
        {
          name: "Automation Admin",
          path: "/autopricing-admin",
          isHidden: !this.isEditor
        }
      ];
    }
  }
};
</script>
